import type { CEventsCalendarTranslations } from "./pl";

export const en: CEventsCalendarTranslations = {
  emptyData: "No data to display.",
  emptyList: "No events to display.",
  emptyFiltered: "No events for the selected period.",
  readMore: "View ->",
  backToList: "<- Back to list",
  filtersLegend: "Pick an event date",
  allYears: "Year",
  allMonths: "Month",
  resetFilter: "Clear filter",
  gallery: "Gallery",
  monthName: (m) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    return months[m - 1] ?? String(m);
  },
  /** `formatDate("2026-05-13")` -> "13 May 2026". */
  formatDate: (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
};
